"use client";
import { createGlobalStyle } from "styled-components";
import MollerRegular from "./moller-regular-webfont.woff2.js";
import MollerBook from "./moller-book-webfont.woff2.js";
import MollerMedium from "./moller-medium-webfont.woff2.js";
import MollerBold from "./moller-bold-webfont.woff2.js";
const MollerFont = createGlobalStyle`
@font-face {
    font-family: 'Moller';
    src: url(${MollerRegular});
    font-weight: 400;
}

@font-face {
    font-family: 'Moller';
    src: url(${MollerBook});
    font-weight: 500;
}

@font-face {
    font-family: 'Moller';
    src: url(${MollerMedium});
    font-weight: 600;
}

@font-face {
    font-family: 'Moller';
    src: url(${MollerBold});
    font-weight: 700;
}
`;
export {
  MollerFont
};
